export default __webpack_public_path__ + "b28276daa215c700dd56ddac319eed5f.svg";